import { RoomServiceIcon } from './RoomServiceIcon';

/**
 * author: Google
 * id C525BD2B-2BA8-4158-AC0A-FAEE9E353047
 * name room-service
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/room-service.svg
 * tags
 */
export const CallBellIcon = RoomServiceIcon;
export default CallBellIcon